import React, { useContext, useState } from 'react'
import Option from 'app/React/Components/Form/ColorOption'
import Tip from 'app/React/Components/misc/Tip'
import { getCurrentPrice, getSecurityDeposit } from 'app/React/Helpers/PriceHelper'
import { validateSteps } from 'app/React/Helpers/StepHelper'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function ColorSetting(props) {
  const {
    cartItems,
    currentEngineTransmission,
    currentVariant,
    isDealerConfigurator,
    lang,
    order,
    strings,
    setColorImage,
    setOrder,
    setValidSteps
  } = useContext(ConfiguratorContext)

  const priceStrings = strings.price.formats ?? {}
  const pickedColor = strings.misc.picked_color ?? 'Farve valgt'

  const [hoverColorOption, setHoverColorOption] = useState(order.configuration.color)

  const setting = props.setting
  const options = Array.isArray(setting.options) ? { ...setting.options } : setting.options
  let optionValues = Object.values(options).filter((o) => o.hide_on !== order.paymentType && o.hide_on !== 'all')
  optionValues = Object.values(options).filter((o) => o.required_engine === undefined || o.required_engine?.length === 0 || o.required_engine?.includes(currentEngineTransmission.engine_id))

  const [checked, setChecked] = React.useState(
    typeof order.configuration[setting.id] === 'object' && order.configuration[setting.id] !== null ? order.configuration[setting.id].id : null
  )

  React.useEffect(() => {

    if (optionValues.length === 0) {
      return
    }

    if (typeof order.configuration[setting.id] !== 'object' || order.configuration[setting.id] === null) {
      setChecked(null)
      return
    }

    if (optionValues.find((o) => o.id === order.configuration[setting.id].id) !== undefined) {
      setChecked(order.configuration[setting.id].id)
      return
    }

    const colorOption = optionValues[0]

    order.configuration.color = colorOption
    order.security_deposit = getSecurityDeposit(order.paymentType, order, currentVariant, currentEngineTransmission, cartItems)
    order.price = getCurrentPrice(order.paymentType, order, currentVariant, cartItems)

    setOrder({ ...order })

    // Color Image Shctuff
    setColorImage(colorOption)

    setValidSteps(validateSteps(currentVariant.steps ?? {}, order, isDealerConfigurator, currentVariant))

    setChecked(optionValues[0].id)
  }, [order, setting])

  if (optionValues.length === 0 || optionValues.filter((o) => o.hide_on !== order.paymentType).length <= 0) {
    return null
  }

  let option_elements = optionValues.map((c, key) => (
    <Option
      key={c.id}
      option={c}
      layout={setting.layout}
      settingid={setting.id}
      onChange={props.onChange}
      checked={checked}
      setChecked={setChecked}
      required={setting.required}
      setHoverColorOption={setHoverColorOption}
    />
  ))

  const colorOptionName = () => {
    const shownColorOption = hoverColorOption !== null ? hoverColorOption : order.configuration.color
    let name = shownColorOption.title?.length > 0 ? shownColorOption.title : shownColorOption.name

    if (typeof shownColorOption.roof_title === 'string' && shownColorOption.roof_title.length >= 0) {
      name += `, ${shownColorOption.roof_title}`
    }

    if (typeof shownColorOption.code === 'string' && shownColorOption.code.length >= 0) {
      name += ` (${shownColorOption.code})`
    }

    return name
  }

  const colorOptionPrice = () => {
    const shownColorOption = hoverColorOption !== null ? hoverColorOption : order.configuration.color
    let price = null

    if (order.paymentType === 'leasing') {
      if (typeof shownColorOption.price_leasing !== 'undefined' && !isDealerConfigurator) {
        price = shownColorOption.price_leasing
      }
    } else {
      if (typeof shownColorOption.price !== 'undefined' && !isDealerConfigurator) {
        price = shownColorOption.price
      }
    }

    if (price === null) {
      return ''
    }

    price = '+' + new Intl.NumberFormat(lang).format(price)
    price += ' '
    price += order.paymentType === 'leasing' ? priceStrings.leasing : priceStrings.cash

    return price
  }

  return (
    <>
      <div className='setting' data-setting-id={setting.id}>
        <h3 className='config-subtitle'>
          {setting.label}
          {typeof setting.description === 'string' && setting.description.length > 0 ? (
            <Tip button='Ok' content={setting.description}/>
          ) : null}
        </h3>
        <div className='config-color-subtitle'>
          {pickedColor}:&nbsp;
          <span>{colorOptionName()}</span>
          &nbsp;
          {colorOptionPrice()}
        </div>
        <div className='config-radio'>{option_elements}</div>
      </div>
      <div className='config-seperator'/>
    </>
  )
}
